import { SeoSlugEnum } from '@rover/constants/src/search/seo.constants';
import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { selectors as citiesAndNeighborhoodsSelectors } from '@rover/react-lib/src/redux/ducks/citiesAndNeighborhoods.duck';
import { useApiCitiesAndNeighborhoodsList } from '@rover/rsdk/src/apiClient/latest/api-cities-and-neighborhoods-list';
import { PaginatedBrandLocalityServiceCitiesItemList } from '@rover/rsdk/src/apiClient/latest/model/paginatedBrandLocalityServiceCitiesItemList';
import { getURL } from '@rover/shared/js/utils/getFullUrl';
import { getCountryUrlPrefix, US_COUNTRY_URL_PREFIX } from '@rover/utilities/roverGeo.constants';

import useDucks from './useDucks';

const selector = citiesAndNeighborhoodsSelectors.getCitiesAndNeighborhoods;

const useCitiesAndNeighborhoodsShim = (
  serviceType: SeoSlugEnum
): PaginatedBrandLocalityServiceCitiesItemList => {
  const { isReactQueryRoute } = usePageContext();
  const url = getURL();
  const path = url.pathname;
  const countryUrlPrefix = getCountryUrlPrefix(path) ?? US_COUNTRY_URL_PREFIX;
  const { data: selectedData } = useDucks({ selector });
  const { data: reactQueryData } = useApiCitiesAndNeighborhoodsList(
    { countryUrlPrefix, serviceType },
    {
      query: { enabled: isReactQueryRoute },
    }
  );

  return isReactQueryRoute ? reactQueryData ?? { results: [] } : selectedData;
};

export default useCitiesAndNeighborhoodsShim;
